import React, { useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { UserStoryFlowDataContext } from "../UserStoryMainPage";
import UserStoryComponent from "../../output-components/user-story/UserStoryComponent";
import EvaluateSummary from "../../output-components/user-story/EvaluationSummaryComponent";
import { Box, Typography } from "@mui/material";
import RefinedUserStoryComponent from "../../output-components/user-story/RefinedUserStoryComponent";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import { businessProcessGuide } from "../../../services/webServices";

const UserStoryOutputPage = () => {
  const location = useLocation();
  const { userStory, evaluationSummary, refinedUserStory, useCase } = useMemo(
    () =>
      location.state || {
        userStory: {},
        evaluationSummary: [],
        refinedUserStory: {},
        useCase: {},
      },
    [location.state]
  );

  const {
    setUserStory,
    setEvaluationSummary,
    setRefinedUserStory,
    setUseCase,
  } = useContext(UserStoryFlowDataContext);

  useEffect(() => {
    setUserStory(userStory);
    setEvaluationSummary(evaluationSummary);
    setRefinedUserStory(refinedUserStory);
    setUseCase(useCase);
  }, [userStory, evaluationSummary, refinedUserStory, useCase]);

  return (
    <Box
      sx={{
        width: "100%",
        mx: "auto",
        px: { xs: 1, sm: 2, md: 3 },
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pb: "30px",
      }}
    >
      {/* Inner Container with Responsive Max Width */}
      <Box
        sx={{
          width: "100%",
          mx: "auto",
          maxWidth: {
            xs: "100%",
            sm: "100%",
            md: "95%",
            lg: "90%",
            xl: "1266px",
          },

          my: 2,
          "& > *:not(:last-child)": {
            mb: 2,
          },
        }}
      >
        {/* Sticky Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          // position="sticky"
          top={0}
          zIndex={10}
          py={1}
          bgcolor="#f6f3f2"
        >
          <Box display="flex" alignItems="center">
            <AutomateIcon style={{ marginRight: 4 }} />
            <Typography
              variant="body2"
              color="text.secondary"
              fontSize={12}
              sx={{ mt: 0.5 }}
            >
              Refine user stories to create detailed requirements.
            </Typography>
          </Box>
          {/* <FullscreenToggle /> */}
        </Box>

        {/* Dynamic Components */}
        {!!Object.keys(userStory).length && <UserStoryComponent />}
        {!!evaluationSummary.length && <EvaluateSummary />}
        {!!Object.keys(refinedUserStory).length && (
          <RefinedUserStoryComponent />
        )}
      </Box>

      {/* Fixed Footer */}
      <Box
        component="footer"
        sx={{
          width: "100%",
          // maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
};

export default UserStoryOutputPage;
